import { render, staticRenderFns } from "./SaudiMap.vue?vue&type=template&id=3b96a0e5"
import script from "./SaudiMap.vue?vue&type=script&lang=js"
export * from "./SaudiMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports